export default function stopPropagation(e) {
	e.stopPropagation();
}
